import React from 'react';
import ModelEntity from "../../../../../../model2/model-entity";
import FieldProto from "../../../../../proto/field-proto";

type Props = {
    field               : FieldProto,
    value?              : any,
    model               : ModelEntity           // some dropdowns need model to build options i.e. taskAssignee is based on projectId

    configOptions?      : any   // ??? what type is it ?
    disabled?           : boolean,

    onChange?           : onChangeCallback,

    className?          : string
}

type State = {
    initialPropsValue   : any
    currentOption       : any
    showPopover         : boolean
}

export default class DropdownFormView extends React.Component<Props,State> {

    constructor(props:Props) {
        super(props);

        this.state = {
            initialPropsValue   : props.value, // required to check if currentOption update needed on props changed
            currentOption       : props.field._getOption(props.value, props.model),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:Props, state:State) {
        if (props.value !== state.initialPropsValue) {
            return {
                initialPropsValue: props.value,
                currentOption: props.field._getOption(props.value, props.model),
            }
        } else {
            return state
        }
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()

        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option: Option | null) => {
        if (!option || (_.isNil(option.value) && !this.props.field.hasOptionWithNullValue)) option = null;

        this.setState({
            currentOption: option
        }, () => {
            if (this.props.onChange) this.props.onChange(_.get(option, 'value', null));
            this.hidePopover()
        });
    }

    render() {
        const {field}   = this.props;

        const classes   = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        });

        // need check value because of none
        if (this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))) {
            return (
                <field.components.FormValueNotEmpty className       = {classes}
                                                    field           = {field}
                                                    option          = {this.state.currentOption}
                                                    configOptions   = {this.props.configOptions}
                                                    disabled        = {this.props.disabled}
                                                    onClick         = {this.showPopover}
                                                    onOptionClick   = {this.onOptionClick}>
                    {this.state.showPopover &&
                        <field.components.PopoverMenu {...this.props} parent={this} />
                    }

                </field.components.FormValueNotEmpty>
            );
        }

        // No value
        return (
            <field.components.FormValueEmpty className      = {classes}
                                             field          = {field}
                                             configOptions  = {this.props.configOptions}
                                             disabled       = {this.props.disabled}
                                             onClick        = {this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
            </field.components.FormValueEmpty>
        );
    }
}
